import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

import * as types from "@recipient/store/types";

import UserListItem from "../UserListItem/UserListItem.vue";

@Component({
  name: "TreeListItem",
  components: {
    UserListItem,
  },
  computed: {
    ...mapGetters({
      selectedItems: types.RECIPIENT_USER_SELECT,
      users: types.RECIPIENT_USER_LIST,
    }),
  },
})
export default class TreeListItem extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object }) item!: recipient.TreeListItem;
  @Prop({ type: [String, Function] }) hasChildrenField!:
    | string
    | recipient.EvaluateTreeListItemHasChildrenFuction;

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  delay: number = 100;
  clicks: number = 0;
  timer: any = null;

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  users!: recipient.Department[];
  selectedItems!: {
    [key: string]: recipient.OrgPerson | recipient.Department;
  };

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  get isSelected() {
    const { deptCode } = this.item as any;
    return deptCode in this.selectedItems;
  }

  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: W A T C H : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Watch("item.expanded")
  onExpanded(newValue: boolean): void {
    if (newValue != undefined && newValue === true) {
      this.$emit("expand", this.item);
    }
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  // hasChildren(): boolean {
  //   if (typeof this.hasChildrenField === "string") {
  //     return (this.item as any)[this.hasChildrenField];
  //   } 
  //   else {
  //     console.log('Item', (this.item));
  //     return this.hasChildrenField(this.item as any);
      
  //   }
  // }

  select(event: MouseEvent, item: recipient.TreeListItem) {
    this.$emit("select", item);
    this.$nextTick(() => this.clearSelection());
    // event.preventDefault();
    // const _this = this;
    // this.clicks++;
    // if (this.clicks === 1) {
    //   var self = this;
    //   this.timer = setTimeout(function() {
    //     self.clicks = 0;
    //   }, this.delay);
    // } else {
    //   this.clearSelection();
    //   clearTimeout(this.timer);
    //   this.clicks = 0;
    // }
  }

  expand(item: recipient.TreeListItem) {
    if (!this.item.expanded) {
      (item as any).users = undefined;
    }

    this.$emit("expand", item);
    var count = 0;

    var trigger = setInterval(() => {
      count++;
      if ((this.item as any).users) {
        this.item.expanded = !this.item.expanded;
        this.$nextTick(() => this.clearSelection());
        clearInterval(trigger);
      } else {
        if (count > 1000) {
          clearInterval(trigger);
        }
      }
    }, 11)
  }

  clearSelection() {
    if (window.getSelection) {
      var sel = window.getSelection();
      sel?.removeAllRanges();
    }
  }
}
